import { KecamatanRepositoryInterface } from '../../../data/contracts/Kecamatan';
import { KecamatanDataMapper } from '../../../data/mappers/Kecamatan';
import { Endpoints } from '../../misc/Endpoints';
import ApiService from '../../services/ApiService';
import { Kecamatan } from '../../../entities/Kecamatan';

export class KecamatanApiRepository implements KecamatanRepositoryInterface {
  private apiService: ApiService;
  private mapper: KecamatanDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: KecamatanDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  public async getAllKecamatan(
    page: number,
    rows: number,
    keyword: string
  ): Promise<Kecamatan[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.kecamatan(),
      {
        page: page,
        rows: rows,
        keyword: keyword,
      },
      null,
      headers
    );
    return this.mapper.convertKecamatanDataFromApi(dataResponse);
  }

  public async getKecamatanById(id: number): Promise<Kecamatan[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.kecamatan() + '/' + id,
      {},
      null,
      headers
    );
    return this.mapper.convertKecamatanDataFromApi(dataResponse);
  }

  public async createKecamatan(
    kabupaten_id: string,
    nama_kecamatan: string
  ): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.wilayahKecamatan(),
      {
        kabupaten_id: kabupaten_id,
        nama_kecamatan: nama_kecamatan,
      },
      null,
      headers
    );
    return dataResponse;
  }

  public async updateKecamatan(
    id: number,
    kabupaten_id: string,
    nama_kecamatan: string
  ): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'post',
      this.endpoints.wilayahKecamatan() + '/' + id,
      {
        kabupaten_id: kabupaten_id,
        nama_kecamatan: nama_kecamatan,
      },
      null,
      headers
    );
    return dataResponse;
  }

  public async deleteKecamatan(id: number): Promise<any> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'delete',
      this.endpoints.wilayahKecamatan() + '/' + id,
      {},
      null,
      headers
    );
    return dataResponse;
  }
}
